/** EST3 equipment component kinds — mirrors backend EQUIPMENT_COMPONENT_KINDS. */
export const EST3_EQUIPMENT_COMPONENT_KINDS = [
  'BASE',
  'FUEL',
  'OPERATOR',
  'MAINT',
  'MOB',
  'DEMOB',
  'STANDBY',
  'OTHER',
] as const;

export type Est3EquipmentComponentKind = (typeof EST3_EQUIPMENT_COMPONENT_KINDS)[number];

export const EST3_EQUIPMENT_DURATION_UOMS = ['HOUR', 'DAY', 'WEEK', 'MONTH', 'SHIFT'] as const;

export const EST3_EQUIPMENT_OWNERSHIP_MODES = ['OWNED', 'RENTED', 'EXTERNAL', 'INTERNAL'] as const;

export function summarizeEquipmentComponents(components: any[]): {
  byKind: Array<{ kind: string; amount: number }>;
  plantTotal: number;
} {
  const map = new Map<string, number>();
  let plantTotal = 0;
  for (const c of components) {
    const kind = String(c.component_kind || 'BASE');
    const amt = Number(c.amount) || 0;
    map.set(kind, (map.get(kind) || 0) + amt);
    plantTotal += amt;
  }
  const byKind: Array<{ kind: string; amount: number }> = EST3_EQUIPMENT_COMPONENT_KINDS.map((kind) => ({
    kind,
    amount: map.get(kind) || 0,
  })).filter((x) => x.amount > 0);
  for (const [kind, amount] of map) {
    if (!EST3_EQUIPMENT_COMPONENT_KINDS.includes(kind as Est3EquipmentComponentKind)) {
      byKind.push({ kind, amount });
    }
  }
  return { byKind, plantTotal };
}
